/**
 * Asynchronously loads the component for AttributeRule
 */

import { lazyLoad } from 'utils/loadable';

export const AttributeRule = lazyLoad(
  () => import('./index'),
  module => module.AttributeRule
);
